/* Компонент раздела "Финансы" мобильной версии */
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import {
    IPay,
    IPayment,
    IPaySystem,
    IServicePayment,
} from '../../interfaces/payment.interface';
import { IPatient } from '../../interfaces/patient';
import { PaymentsService } from '../../services/payments.service';
import { PatientService } from '../../services/patient.service';
import { AlertService } from 'src/lib/ariadna/alert';

import { LoadService } from '../../services/application/load.service';
import { Title } from '@angular/platform-browser';
import { IPeriod } from 'src/app/interfaces/period.interface';
import moment from 'moment';
import {
    onIfAnimation,
    topButtonAnimation,
} from '../../animations/show-left-right.animation';
import {
    expandedAnimation,
    heightAnimation,
} from '../../animations/height.animation';
import {
    getStrEnd,
    getTekDay,
    getNameDay,
    getTime,
    strToDate,
    getDayWithYear,
} from '../application/global.function';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PayDetailsDialogComponent } from './dialogs/pays-details-dialog/pay-details-dialog.component';
import { PayPeriodDialogComponent } from './dialogs/pay-period-dialog/pay-period-dialog.component';
import { IDateRange } from 'src/app/interfaces/date-range.interface';
import { RefundComponent } from 'src/app/modals/refund/refund.component';
import { RecordService } from 'src/app/services/record.service';
import { lastValueFrom } from 'rxjs';
import { Store } from 'src/app/services/store.service';

interface ILoyalCard {
    number_card: number | null;
    name_programm: string | null;
    discount: number | null;
    bonus_amount: number | null;
}

@Component({
    selector: 'app-payments',
    templateUrl: './payments.component.html',
    styleUrls: ['./payments.component.scss'],
    animations: [
        topButtonAnimation,
        heightAnimation,
        expandedAnimation,
        onIfAnimation,
    ],
})
export class PaymentsComponent implements OnInit, OnDestroy {
    @ViewChild('inputFocus') inputFocusRef!: ElementRef;
    @ViewChild('inputFocus2') inputFocusRef2!: ElementRef;
    @ViewChild('mymyselect') mymyselect!: any;
    @ViewChild('paymentsContainer')
    paymentsContainer!: ElementRef;
    @HostListener('window:scroll', ['$event'])
    animState = 'on';
    payAvansAnimeStatus = 0; // закрыта форма оплаты баланса
    dtBegin: Date | null = null; // Дата начала
    dtEnd: Date | null = null; // Дата ококнчания
    dtBegins: Date | null = null;
    dtEnds: Date | null = null;
    isLoading = false;
    paymentsList: IPayment[] | null = null; // Список платежей
    animateStateServices: string[] = []; // Статус анимации для услуг
    private _patient!: IPatient;
    paymentsListLength: number = 0; // Сколько всего записей
    countRecToPage = 15; // Количетсво записей на странице mobile
    paySystem: IPaySystem | null = null; // Тип платежной системы
    // paySystemField: string = '';
    private _setting: any;
    date!: IDateRange;
    //новые переменные
    periodText = '';
    loadingMoreContent = false;
    payPages: Array<IPayment[]> = [];
    countOfPages = 0;
    loadedPages = 1;
    viewPage = 0;
    servicesListLength: number = 0;
    showMyContainer: boolean = false;
    showMyPay: boolean = false;
    dt_begin = this.dtBegin;
    dt_end = this.dtEnd;
    visibill: boolean = false;
    scrolled: boolean = false;
    private resizeHandler!: () => void;
    isMobile: boolean = false;
    selectedButton: 'today' | '3days' | 'all' | null = 'all';
    isLoyaltyCardCollapsed = false;
    loyaltyCard: ILoyalCard = {
        number_card: null,
        name_programm: null,
        discount: null,
        bonus_amount: null,
    };

    priceMapper = {
        '=0': 'рублей',
        '=1': 'рубль',
        '=2': 'рубля',
        other: 'рублей',
    };
    servicesMapper = {
        '=0': 'услуг',
        '=1': 'услуга',
        '=2': 'услуги',
        other: 'услуг',
    };
    //pc version
    page = 1;
    loadingPaymentsList = false; // Загрузка
    countRectoPage = 15; // Количетсво записей на странице
    scrollTimeout: any = null;
    isLoyaltyCardVisible = false;

    /* Инициализация компонента */
    constructor(
        private paymentsService: PaymentsService,
        private patientService: PatientService,
        private alert: AlertService,
        private load: LoadService,
        private dialog: MatDialog,
        private title: Title,
        private rs: RecordService,
        private cdr: ChangeDetectorRef,
    ) {
        this._setting = this.load.configData.pages.payments;
        if (this._setting && this._setting.title) {
            this.title.setTitle(this._setting.title);
        }
        this.date = { dt_begin: new Date(), dt_end: new Date() };
    }

    /** Действия при инициализации компонента */
    ngOnInit(): void {
        moment.locale('ru');
        const token = Store.getTokenFromCookie();
        Store.getDataString('ParentCookieName')
            ? this.getPatientInfo(true, token!)
            : this.getPatientInfo();

        this.date.dt_begin?.setDate(this.date.dt_begin.getDate() - 365);
        this.isMobile = window.innerWidth <= 767;

        // Правильная инициализация пагинации
        this.loadedPages = 1;
        this.viewPage = 1;

        this.dtBegins = new Date();
        this.dtBegins.setDate(this.dtBegins.getDate() - 365);
        this.dtEnds = new Date();

        const bonusSystemTypes =
            this.load.configData.pages.personal?.WEB_LK_BONUS_SYSTEM_TYPES;
        this.isLoyaltyCardVisible = bonusSystemTypes === 'visible';

        // РАЗДЕЛЯЕМ ЛОГИКУ ДЛЯ МОБИЛЬНОЙ И ДЕСКТОПНОЙ ВЕРСИЙ

        if (this.isMobile) {
            this.initMobileData();
        } else {
            this.initDesktopData();
        }

        this.resizeHandler = () => {
            this.isMobile = window.innerWidth <= 767;
        };

        window.addEventListener('resize', this.resizeHandler);
        window.addEventListener('scroll', () => this.onScroll());
    }

    ngOnDestroy() {
        window.removeEventListener('scroll', () => this.onScroll());
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    }

    private async initMobileData() {
        this.isLoading = true;
        await this.getPaySystem();
        try {
            await this.changePeriod({
                dt_begin: this.date.dt_begin,
                dt_end: this.date.dt_end,
            });
            this.formatDateToString(this.date);
        } finally {
            this.isLoading = false;
        }
    }

    // Исправленный метод для десктопной версии
    private async initDesktopData() {
        try {
            await this.getPaySystem(); // Тип платежной системы

            // Устанавливаем правильные даты для десктопа
            this.dtBegin = new Date();
            this.dtBegin.setDate(this.dtBegin.getDate() - 365);
            this.dtEnd = new Date();

            this.changePeriodPc({ begin: this.dtBegin, end: this.dtEnd });
        } catch (error) {
            this.alert.warn('Ошибка при загрузке страницы.');
        }
    }

    canLoadNextPage(): boolean {
        return (
            !this.loadingMoreContent &&
            !this.loadingPaymentsList &&
            this.loadedPages < this.countOfPages
        );
    }
    getPatientInfo(isFamilyAccount = false, tokenValue?: string) {
        const result = lastValueFrom(
            this.patientService.getServerPatientInfo$(
                tokenValue,
                isFamilyAccount,
            ),
        );
        result
            .then((info) => {
                this._patient = info;

                this.loyaltyCard = {
                    number_card: info.user_card_info?.number_card || null,
                    name_programm: info.user_card_info?.name_programm || null,
                    discount: info.user_card_info?.discount || null,
                    bonus_amount: info.user_card_info?.bonus_amount || null,
                    // number_card: null,
                    // name_programm: null,
                    // discount: null,
                    // bonus_amount: null,
                };
                this.cdr.detectChanges();
            })
            .catch((error) => console.error('getPatientInfo', error));
    }

    get isLoyaltyCardInactive(): boolean {
        const card = this.loyaltyCard;
        return card.discount === null && card.bonus_amount === null;
    }

    /** Получение типа платежной системы (телефон или почта) */
    async getPaySystem() {
        this.paySystem = null;
        // this.paySystemField = '';

        try {
            const info = await this.paymentsService.getPaySystem();

            this.paySystem = info[0];
            // this.paySystemField = this.paySystem.requiredfieldcodes[0];
        } catch (error) {
            console.error('Ошибка во время определения платёжной системы');
        }
    }

    //computed boolean function для возвратов
    isNotRefundPayment(payInfo: IPayment): boolean {
        return (payInfo.all_amount || 1) > 0;
    }

    /** Показ блока с платёжной информацией */
    showPay() {
        if (this.animState === 'on') {
            this.animState = 'off';
        } else {
            this.animState = 'on';
        }
    }

    /** Оплата, абонемент toggle */
    ShowTogglePopup(): void {
        this.showMyContainer = !this.showMyContainer;
        if (this.showMyPay === false) {
            setTimeout(() => {
                this.mymyselect.open();
            }, 0);
        }
    }

    /** Скрытие/показ платёжного попапа */
    ShowTogglePopupPay(): void {
        this.showMyContainer = !this.showMyContainer;

        if (this.showMyContainer === true) {
            setTimeout(() => {
                this.inputFocusRef.nativeElement.focus();
            }, 0);
        }
    }

    /** Оплатить */
    toPayPc(pay: IPayment) {
        if (pay.confirmation_url && pay.confirmation_url.length > 5) {
            window.open(pay.confirmation_url);
        }
    }

    /** Возможна ли оплата */
    isPayPc(pay: IPayment): boolean {
        if (
            pay.confirmation_url &&
            pay.confirmation_url.length > 5 &&
            pay.paystatus == 0
        ) {
            return true;
        } else {
            return false;
        }
    }

    /* Оплата */
    // async goPayPc(p: IPay) {
    //     try {
    //         const pay = await lastValueFrom(
    //             this.paymentsService.getPayTemp(
    //                 22,
    //                 p.sum,
    //                 p.email,
    //                 p.phone,
    //                 null
    //             )
    //         );
    //         if (pay.identity) {
    //             const paymentOrder = await lastValueFrom(
    //                 this.paymentsService.getPayOrder(pay.identity)
    //             );
    //             if (paymentOrder.confirmationurl) {
    //                 window.location.href = paymentOrder.confirmationurl;
    //             } else {
    //                 throw new Error('Отсутствует confirmationurl');
    //             }
    //         } else {
    //             throw new Error('Отсутствует identity');
    //         }
    //     } catch (error) {
    //         this.alert.warn(
    //             'Ошибка создания платежа в платежной системе. Проверьте данные и попробуйте снова.',
    //             10000
    //         );
    //     }
    // }

    // Todo: Убрать эти анимации. Или просто заменить их на более короткие.
    /** Показать/скрыть услуги */
    public showHideListservicesPc(index: number) {
        if (this.animateStateServices) {
            if (this.animateStateServices[index] === 'off') {
                this.animateStateServices[index] = 'on';
            } else {
                this.animateStateServices[index] = 'off';
            }
        }
    }

    // /** Нажатие Enter на поле суммы оплаты по абонементу */
    // canselFocused(abon: any) {
    //     this.inputFocusRef2.nativeElement.blur();
    //     this.goPay(abon);
    // }
    // /** Нажатие Enter на поле суммы оплаты по абонементу */
    // canselFocused2(abon: any) {
    //     this.inputFocusRef.nativeElement.blur();
    //     this.goPay(abon);
    // }

    /** Получение количества услуг */
    async getServicesSize() {
        this.paymentsList = null;
        this.loadingMoreContent = true;

        try {
            const res = await lastValueFrom(
                this.paymentsService.getPaymentsSize(
                    this.date.dt_begin,
                    this.date.dt_end,
                ),
            );

            if (res.size) {
                this.servicesListLength = res.size;
            } else {
                this.servicesListLength = 0;
            }

            this.setCountOfPages();

            // Загружаем первую страницу данных
            if (this.servicesListLength > 0) {
                await this.loadMoreServices(1, this.countRecToPage);
            }
        } catch (error) {
            this.alert.error('Ошибка при загрузке записей');
        } finally {
            this.loadingMoreContent = false;
        }
    }

    /** Изменение периода для вывода записей*/
    async changePeriod(dateRange: IDateRange) {
        this.date = dateRange;

        this.payPages = [];
        this.paymentsList = null;

        await this.getServicesSize();
        this.formatDateToString(this.date);
        this.periodText = this.getPeriodText(this.date);

        this.loadedPages = 1;
        this.viewPage = 1;
    }
    /** Подгрузка дополнительного кал-ва услуг */
    async loadMoreServices(pStart?: number, pEnd?: number) {
        try {
            const res = await lastValueFrom(
                this.paymentsService.getPayments(
                    this.date.dt_begin,
                    this.date.dt_end,
                    pStart,
                    pEnd,
                ),
            );

            res.forEach((item) => {
                item.dtSort = strToDate(item.pt_dat_str);
                item.pt_dat = strToDate(item.pt_dat_str);
            });

            if (res && res.length > 0) {
                // Для первой загрузки или сброса
                if (pStart === 1) {
                    this.payPages = [res];
                    this.paymentsList = [...res];
                } else {
                    // Для последующих загрузок
                    this.payPages.push(res);
                    this.paymentsList = this.paymentsList
                        ? [...this.paymentsList, ...res]
                        : [...res];
                }
            }
        } catch (error) {
            this.alert.error('Ошибка при загрузке списка платежей');
            console.error(error);
            throw error;
        }
    }

    /** Загрузка следующей страницы с услугами */
    // loadNextPage() {
    //     this.loadedPages++;
    //     this.loadMoreServices(
    //         this.loadedPages * this.countRecToPage - this.countRecToPage + 1,
    //         this.loadedPages * this.countRecToPage
    //     );
    // }

    async loadNextPage() {
        // Проверяем условия для загрузки следующей страницы
        if (
            this.loadingMoreContent ||
            this.loadedPages >= this.countOfPages ||
            this.loadingPaymentsList
        ) {
            return;
        }

        try {
            // Устанавливаем флаг загрузки сразу
            this.loadingMoreContent = true;

            // Увеличиваем счетчики только после начала загрузки
            this.loadedPages++;

            // viewPage увеличиваем только для мобильной версии
            if (this.isMobile) {
                this.viewPage++;
            }

            // Мобильная версия - добавляем к существующим данным
            await this.loadMoreServices(
                this.loadedPages * this.countRecToPage -
                    this.countRecToPage +
                    1,
                this.loadedPages * this.countRecToPage,
            );
        } catch (error) {
            console.error('Error loading next page:', error);

            // Откатываем счетчики при ошибке
            this.loadedPages--;
            if (this.isMobile) {
                this.viewPage--;
            }

            this.alert.error('Не удалось загрузить данные', 3000);
        } finally {
            // Сбрасываем флаги загрузки
            this.loadingMoreContent = false;
        }
    }

    /** Вызов диалога с деталями услуги */
    showDetailsDialog(serv: IPayment) {
        const detailsDialog = this.dialog.open(PayDetailsDialogComponent, {
            maxWidth: '100%',
            maxHeight: '100%',
            panelClass: 'payModalDialog',
            data: {
                service: serv,
            },
        });

        detailsDialog.afterClosed().subscribe((result) => {});
    }

    //надо добавить в массив и отсортировать
    /** манипуляции с датой */
    isBlockYeerPc(index: number): boolean {
        let f = false;

        if (this.paymentsList?.[index - 1]) {
            if (
                this.paymentsList[index].dtSort.getFullYear() !==
                this.paymentsList[index - 1].dtSort.getFullYear()
            ) {
                f = true;
            }
        }
        if (index === 0) {
            f = true;
        }

        return f;
    }

    /** Получение года платежа по его порядковому номеру */
    getYeerPc(index: number): string {
        if (this.paymentsList?.[index] && this.paymentsList?.[index].pt_keyid) {
            return this.paymentsList[index].dtSort.getFullYear() + '';
        } else {
            return '';
        }
    }
    /** Установка количества страниц*/
    setCountOfPages() {
        this.countOfPages = Math.ceil(
            this.servicesListLength / this.countRecToPage,
        );
    }
    public getDateTimeFuul(dt: Date): string {
        let tmp = '';
        moment.locale('ru');
        tmp =
            moment(dt).format('D MMM YYYY') +
            ' в ' +
            moment(dt).format('HH:mm');
        return tmp;
    }

    /** Получение даты в формате "D MM" */
    getTekDayPc(dt: Date): string {
        return getTekDay(dt);
    }

    /** Получение дня недели */
    getNameDayPc(dt: Date): string {
        return getNameDay(dt);
    }

    /** Получение времени формата "D MM YYYY" */
    getDayWithYear(dtSort: Date) {
        return getDayWithYear(dtSort);
    }

    /** Получение времени формата "HH:mm" */
    getTimePc(dt: Date): string {
        return getTime(dt);
    }

    /** Получение периода текстом в формате "D MMM YYYY"*/
    formatDateToString(dt: IDateRange) {
        if (dt.dt_begin) {
            dt.str_begin = moment(new Date(dt.dt_begin)).format('D MMM YYYY');
        }
        if (dt.dt_end) {
            dt.str_end = moment(new Date(dt.dt_end)).format('D MMM YYYY');
        }
    }

    /** строку в число */
    public numberOnlyReplacePc(str: string): number {
        let resNum = '';
        let i = 0;
        let charCode = 0;
        for (i = 0; i < str.length; i++) {
            charCode = str.charCodeAt(i);
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode != 46
            ) {
            } else {
                resNum = resNum + str[i];
            }
        }
        return Number(resNum);
    }

    /*Для Календаря*/

    /** Вызов диалога для выбора периода */
    showPeriodDialog() {
        const periodDialog = this.dialog.open(PayPeriodDialogComponent, {
            maxWidth: '650px',
            width: '100%',
            height: '100%',
            data: {
                dateRange: {
                    dt_begin: this.date.dt_begin,
                    dt_end: this.date.dt_end,
                } as IDateRange,
            },
        });

        periodDialog.afterClosed().subscribe((result: { date: IDateRange }) => {
            if (result?.date) {
                this.isLoading = true;
                this.changePeriod(result.date).then(
                    () => (this.isLoading = false),
                );
            }
        });
    }

    /** Полученеи текста из периода */
    getPeriodText(dt: IDateRange) {
        let periodText = '';
        let isSelectedOneDay = dt.str_begin == dt.str_end;

        if (isSelectedOneDay) {
            if (dt.dt_begin == null && dt.dt_end == null)
                periodText = 'Платежи за всё время';
            else if (dt.dt_begin?.toDateString() == new Date().toDateString())
                periodText = 'Последние платежи';
            else if (dt.str_begin) periodText = dt.str_begin;
        } else if (dt.dt_begin && dt.dt_end) {
            const yearAgo = moment(dt.dt_end).subtract(1, 'year');
            if (yearAgo.isSame(dt?.dt_begin)) {
                const yearAgo = moment(dt.dt_end).subtract(1, 'year');

                periodText = `За 1 год`;
            } else {
                periodText = `${dt.str_begin} - ${dt.str_end}`;
            }
        } else if (dt.str_begin) {
            periodText = dt.str_begin;
        } else if (dt.str_end) {
            periodText = dt.str_end;
        }
        return periodText;
    }

    /**
     * Фильтрация записей по дате
     * @param {number | null} startOffset Сдвиг даты С
     * @param {number | null} endOffset Сдвиг даты ПО
     */
    btnFilterByDate(
        startOffset: number | null = 0,
        endOffset: number | null = 0,
    ) {
        if (startOffset !== null && endOffset !== null) {
            this.date.dt_begin = new Date();
            this.date.dt_begin.setDate(
                this.date.dt_begin.getDate() - startOffset,
            );
            this.date.dt_end = new Date();
            this.date.dt_end.setDate(this.date.dt_end.getDate() - endOffset);
            this.isLoading = true;
            this.changePeriod({
                dt_begin: this.date.dt_begin,
                dt_end: this.date.dt_end,
            }).then(() => (this.isLoading = false));
        } else {
            this.date.dt_begin = null;
            this.dt_begin = this.date.dt_begin;
            this.date.dt_end = null;
            this.dt_end = this.date.dt_end;
            this.isLoading = true;
            this.changePeriod({ dt_begin: null, dt_end: null }).then(() => {
                this.isLoading = false;
            });
        }
    }
    //pc version
    async initData() {
        try {
            this.getPaySystem(); // Тип платежной системы

            this.changePeriodPc({ begin: this.dtBegin, end: this.dtEnd });
        } catch (error) {
            this.alert.warn('Ошибка при загрузке страницы.');
        }
    }

    /** Получить тип платежной системы телефон почта !*/
    async getPaySystemPc() {
        this.paySystem = null;
        // this.paySystemField = '';

        try {
            const info = await this.paymentsService.getPaySystem();

            if (info.length > 0) {
                this.paySystem = info[0];
                // this.paySystemField = this.paySystem.requiredFields;
            }
        } catch (error) {
            this.alert.warn(
                'Ошибка при получении информации о платёжной системе',
            );
        }
    }

    /** За сегодня */
    btnFiltrTek() {
        this.dtBegin = new Date();
        this.dtEnd = new Date();
        // this.selectedButton = this.selectedButton === 'today' ? null : 'today';
        this.selectedButton = 'today';
        this.customDateSelected = false;
        this.changePeriodPc({ begin: this.dtBegin, end: this.dtEnd });
    }

    /** За 3 дня */
    btnFiltr3Day() {
        this.dtBegin = new Date();
        // this.selectedButton = this.selectedButton === '3days' ? null : '3days';
        this.selectedButton = '3days';
        this.customDateSelected = false;
        this.dtBegin.setDate(this.dtBegin.getDate() - 3);
        this.dtEnd = new Date();
        this.changePeriodPc({ begin: this.dtBegin, end: this.dtEnd });
    }
    btnAllDays() {
        this.dtBegin = new Date(2000, 0, 1);
        this.dtEnd = new Date();
        // this.selectedButton = this.selectedButton === 'all' ? null : 'all';
        this.selectedButton = 'all';
        this.customDateSelected = false;
        this.changePeriodPc({
            begin: this.dtBegin,
            end: this.dtEnd,
        });
    }

    changePeriodPc(dt: IPeriod) {
        // Добавьте проверку, чтобы избежать лишних запросов
        if (this.loadingPaymentsList) {
            return;
        }

        if (dt.begin !== null && dt.end !== null) {
            this.dtBegins = dt.begin;
            this.dtEnds = dt.end;
        }
        this.getPaymentsSizePC();
        this.page = 1;
    }
    customDateSelected = false;
    onDateRangeChanged(period: IPeriod) {
        // Обновляем начало и конец периода
        this.dtBegins = period.begin;
        this.dtEnds = period.end;
        this.customDateSelected = true;
        this.selectedButton = 'all';

        // Перезагружаем список платежей
        this.getPaymentsSizePC();
    }

    /** Количество платежей */
    async getPaymentsSizePC() {
        this.paymentsList = null;
        this.loadingPaymentsList = true;
        try {
            const results = await lastValueFrom(
                this.paymentsService.getPaymentsSize(
                    this.dtBegins,
                    this.dtEnds,
                ),
            );

            if (results.size) {
                this.paymentsListLength = results.size;
                await this.getPayments(1, this.countRectoPage);
            } else {
                this.paymentsList = [];
                this.paymentsListLength = 0;
                this.loadingPaymentsList = false;
                // await this.getPayments();
            }
        } catch (error) {
            this.alert.warn('Ошибка при получении количества записей');
        }
    }

    /** Список платежей */
    async getPayments(pStart?: number, pEnd?: number) {
        // this.paymentsList = null;
        this.animateStateServices = [];
        // this.loadingPaymentsList = true;

        try {
            const res = await lastValueFrom(
                this.paymentsService.getPayments(
                    this.dtBegins,
                    this.dtEnds,
                    pStart,
                    pEnd,
                ),
            );
            this.paymentsList = res || [];
            res.forEach((item) => {
                item.dtSort = strToDate(item.pt_dat_str);
                item.pt_dat = strToDate(item.pt_dat_str);

                item.services.forEach((itemS) => {
                    if (itemS.dtstr && itemS.dtstr.length > 10) {
                        itemS.dt = strToDate(itemS.dtstr);
                    }
                });
            });

            this.animateStateServices.push('off');
        } catch (error) {
            this.alert.warn('Ошибка при получении списка платежей');
        } finally {
            this.loadingPaymentsList = false;
            // this.loadingMoreContent = false;
            // this.isLoading = false;
        }
    }

    isBlockYeer(index: number): boolean {
        return (
            (this.paymentsList &&
                this.paymentsList[index] &&
                this.paymentsList[index - 1] &&
                this.paymentsList[index].dtSort.getFullYear() !==
                    this.paymentsList[index - 1].dtSort.getFullYear()) ||
            index === 0
        );
    }

    getYeer(index: number): string {
        if (this.paymentsList && this.paymentsList[index]) {
            return this.paymentsList[index].dtSort.getFullYear() + '';
        } else {
            return '';
        }
    }

    getFullDateTime(dt: Date): string {
        moment.locale('ru');
        return (
            moment(dt).format('D MMM YYYY') + ' в ' + moment(dt).format('HH:mm')
        );
    }

    getTekDay(dt: Date | null): string {
        return dt ? getTekDay(dt) : '';
    }

    getNameDay(dt: Date): string {
        return getNameDay(dt);
    }

    getTime(dt: Date | null): string {
        return dt ? getTime(dt) : '';
    }

    actionClick(pay: IPayment) {
        if (this.isPay(pay)) {
            this.toPay(pay);
        } else if (this.isRefund(pay)) {
            this.toRefund(pay);
        }
    }

    /** Оплатить*/
    async toPay(pay: IPayment) {
        try {
            if (this.isPay(pay)) {
                if (pay.confirmation_url && pay.confirmation_url.length > 5) {
                    window.open(pay.confirmation_url);
                } else {
                    this.loadingPaymentsList = true;

                    const confirmation_url = await this.createPay(pay);

                    if (confirmation_url) {
                        window.open(confirmation_url);
                    }
                }
            }
        } catch (error) {
            this.alert.error(
                'Ошибка открытия платежа, попробуйте повторить операцию позднее.',
            );
        } finally {
            this.loadingPaymentsList = false;
        }
    }

    async createPay(pay: IPayment) {
        let confirmation_url: string | null = null;

        try {
            const newPay = await lastValueFrom(
                this.rs.getPaymentTemp(
                    pay.pt_keyid,
                    this._patient.email,
                    this._patient.phone,
                ),
            );

            if (newPay.identity && newPay.identity > 0) {
                const newPayOrder = await lastValueFrom(
                    this.paymentsService.getPayOrder(newPay.identity),
                );

                if (newPayOrder.confirmationurl) {
                    confirmation_url = newPayOrder.confirmationurl;
                } else {
                    throw new Error('В payOrder отсутствует confirmationurl.');
                }
            } else {
                throw new Error(
                    'С платежами что-то пошло не так. err_text: ' +
                        newPay.err_text,
                );
            }
        } catch (error) {
            this.alert.error(
                'Ошибка создания платежа, попробуйте повторить операцию позднее.',
            );
        }

        return confirmation_url;
    }

    toRefund(pay: IPayment) {
        const dialogOpenOptions: MatDialogConfig = {
            data: pay,
            panelClass: 'refund-panel-class',
        };

        this.dialog.open(RefundComponent, dialogOpenOptions);
    }

    /** Возможна ли оплата */
    isPay(pay: IPayment): boolean {
        return pay.paystatus == 0 && this.paySystem !== null;
    }

    /** Возможен ли возврат */
    isRefund(pay: IPayment): boolean {
        return pay.paystatus === 1;
    }

    /** Строку в число */
    public numberOnlyReplace(str: string): number {
        let resNum = '';
        let i = 0;
        let charCode = 0;
        for (i = 0; i < str.length; i++) {
            charCode = str.charCodeAt(i);
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode != 46
            ) {
            } else {
                resNum = resNum + str[i];
            }
        }
        return Number(resNum);
    }

    /** Оплата */
    async goPay(p: IPay) {
        try {
            const info = await lastValueFrom(
                this.paymentsService.getPayTemp(
                    22,
                    p.sum,
                    p.email,
                    p.phone,
                    null,
                ),
            );

            if (!info.identity)
                throw new Error(
                    'Ошибка создания платежа в системе. Проверьте данные и попробуйте снова',
                );

            const payOrder = await lastValueFrom(
                await this.paymentsService.getPayOrder(info.identity),
            );

            if (!payOrder.confirmationurl) {
                throw new Error(
                    'Ошибка создания платежа в системе. Проверьте данные и попробуйте снова',
                );
            }

            window.location.href = payOrder.confirmationurl;
        } catch (error: any) {
            this.alert.warn(
                'Ошибка создания платежа в системе. Проверьте данные и попробуйте снова.',
                10000,
            );
        }
    }

    /** Событие выбора страницы */
    async changedPage(page: any) {
        this.loadingPaymentsList = true;

        if (page === 1) {
            await this.getPayments(1, this.countRectoPage);
        } else {
            await this.getPayments(
                page * this.countRectoPage - this.countRectoPage + 1,
                page * this.countRectoPage,
            );
        }

        this.page = page;
    }

    showHideListservices(indexPay: number) {
        // Проверка на количество услуг
        if (
            this.paymentsList &&
            this.paymentsList[indexPay] &&
            this.paymentsList[indexPay].services.length > 1
        ) {
            this.animateStateServices.forEach((item, i_item) => {
                // Скрываем все
                if (i_item != indexPay) {
                    this.animateStateServices[indexPay] === 'off';
                } else {
                }
            });

            if (this.animateStateServices[indexPay]) {
                if (this.animateStateServices[indexPay] === 'off') {
                    this.animateStateServices[indexPay] = 'on';
                } else {
                    this.animateStateServices[indexPay] = 'off';
                }
            }
        }
    }

    getShowHideServices(indexPay: number): string {
        let def = 'off';
        def = this.animateStateServices[indexPay];
        return def;
    }

    /*    Дата услуг(и)  */
    getDTSer(d: Date | null): string {
        if (d) {
            return moment(d).format('D MMM YYYY');
        } else {
            return '';
        }
    }

    getPeriodServicesStartEnd(
        services: IServicePayment[],
        isStart = true,
    ): string {
        let dt = '';
        moment.locale('ru');
        // Сортировка
        services.sort((a, b) => {
            if (a.dt && b.dt && a.dt > b.dt) {
                return 1;
            } else {
                return -1;
            }
        });
        const len = services.length;

        const i = isStart ? 0 : len - 1;
        if (services[0].dt && services[len - 1].dt) {
            if (
                services[0].dt.getFullYear() ==
                services[len - 1].dt?.getFullYear()
            ) {
                dt = moment(services[i].dt).format('D MMM');
            } else {
                dt = moment(services[i].dt).format('D MMM YYYY');
            }
        } else {
            if (services[i].dt) {
                dt = moment(services[i].dt).format('D MMM YYYY');
            }
        }

        return dt;
    }

    getStrEndServ(count: number): string {
        return getStrEnd(count, 'услуг', ['а', 'и', '']);
    }
    scrollPosition: any;
    @HostListener('window:scroll', ['$event'])
    onScroll(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();

        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
            if (this.isMobile) {
                // Мобильная версия - проверяем общий скролл страницы
                const scrollPosition = window.pageYOffset;
                const windowSize = window.innerHeight;
                const bodyHeight = document.body.offsetHeight;

                if (
                    !this.loadingMoreContent &&
                    this.loadedPages < this.countOfPages &&
                    scrollPosition + windowSize >= bodyHeight - 100
                ) {
                    this.loadNextPage();
                }
            } else {
                // Десктопная версия - проверяем скролл контейнера
                const paymentsContainer = document.querySelector(
                    '.payments-table__body',
                );
                if (!paymentsContainer) return;

                // Проверяем, что не идет загрузка и есть еще данные для загрузки
                if (
                    this.loadingMoreContent ||
                    this.loadingPaymentsList ||
                    !this.paymentsList ||
                    this.paymentsList.length >= this.paymentsListLength
                ) {
                    return;
                }

                const containerRect = paymentsContainer.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                const isNearBottom = containerRect.bottom <= windowHeight + 100;

                if (isNearBottom) {
                    // Для десктопа используем существующую логику загрузки
                    this.loadNextPageForDesktop();
                }
            }
        }, 200);
    }
    private async loadNextPageForDesktop() {
        if (
            this.loadingPaymentsList ||
            !this.paymentsList ||
            this.paymentsList.length >= this.paymentsListLength
        ) {
            return;
        }

        try {
            this.loadingPaymentsList = true;
            this.loadingMoreContent = true;
            const nextPage =
                Math.floor(this.paymentsList.length / this.countRectoPage) + 1;
            const startIndex = (nextPage - 1) * this.countRectoPage + 1;
            const endIndex = nextPage * this.countRectoPage;

            // Сохраняем текущие данные
            const currentPayments = [...this.paymentsList];

            // Загружаем новую страницу
            await this.getPayments(startIndex, endIndex);

            // Объединяем с существующими данными
            if (this.paymentsList && this.paymentsList.length > 0) {
                this.paymentsList = [...currentPayments, ...this.paymentsList];
            } else {
                this.paymentsList = currentPayments;
            }
        } catch (error) {
            console.error('Error loading next desktop page:', error);
            this.alert.error('Не удалось загрузить данные', 3000);
        } finally {
            this.loadingPaymentsList = false;
            this.loadingMoreContent = false;
        }
    }
    isLastPayment(index: number): boolean {
        return this.paymentsList
            ? index === this.paymentsList.length - 1
            : false;
    }
}
